import React from 'react';
import { useTranslation } from 'react-i18next';
import bannerImage from '../assets/layout/banner.png';
import coroaImage from '../assets/layout/coroa.png';
import './Banner.css';

const Banner = () => {
  const { t } = useTranslation();

  return (
    <section className="banner">
      <div className="banner-background">
        <img src={bannerImage} alt="Banner Convertrex" />
        <div className="banner-overlay"></div>
      </div>
      <div className="banner-content">
        <img src={coroaImage} alt="Coroa" className="coroa-image" />
        <h1 className="banner-title">CONVERTREX</h1>
        <h2 className="banner-slogan">{t('banner.slogan')}</h2>
        <div className="banner-cta">
          <a href="#contact" className="cta-button">
            {t('banner.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Banner;